var getConfig = function () {
  if (process.env.NODE_ENV === 'development') {
    return require('../config.dev.json')
  } else {
    return require('../config.prod.json')
  }
}

// export default
module.exports = getConfig()
